"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BaseSubscriptionService = exports["default"] = /*#__PURE__*/function () {
  function BaseSubscriptionService() {
    _classCallCheck(this, BaseSubscriptionService);
    this.subscription = null;
  }

  /**
   * 1) Tell server to subscribe to level1 data for passed `instrumentId`
   * 2) Get first portion of data
   */
  return _createClass(BaseSubscriptionService, [{
    key: "initSubscription",
    value: function initSubscription(instrumentId) {
      throw Error('not implemented');
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      throw Error('not implemented');
    }

    /**
     * Stop getting updates from server
     */
  }, {
    key: "stop",
    value: function stop() {
      throw Error('not implemented');
    }

    /**
     * Stop getting updates from server for one instrument
     *
     */
  }, {
    key: "stopOne",
    value: function stopOne(insrtumentId) {
      throw Error('not implemented');
    }

    /**
     * Remove listener
     */
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
      this.subscription = null;
    }

    /**
     * 1) Tell server to stop getting updates
     * 2) Remove listener
     */
  }, {
    key: "stopAll",
    value: function stopAll() {
      this.unsubscribe();
      this.stop();
    }
  }]);
}();